import { render } from "./CancerDemographicBaseline.vue?vue&type=template&id=07edf51f&scoped=true"
import script from "./CancerDemographicBaseline.vue?vue&type=script&lang=js"
export * from "./CancerDemographicBaseline.vue?vue&type=script&lang=js"

import "./CancerDemographicBaseline.vue?vue&type=style&index=0&id=07edf51f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07edf51f"]])

export default __exports__